import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Page } from '../models/models';
import { rxState } from '@rx-angular/state';

@Component({
  selector: 'lib-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentComponent {

  // private state = rxState<{ page: Page }>();
  public body = '';

  @Input()
  set page(page: Page) {
    this.body = page.body;
  }
}
